import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSpring, animated, config } from 'react-spring';

const DropDownAdmissions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef();

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const fadeInOut = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: `scaleY(${isOpen ? 1 : 0.8})`,
    config: config.default,
    delay: isOpen ? 0 : 200,
  });

  return (
    <div
      className="relative group"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="text-amber-300 text-lg font-normal font-['DM Sans'] capitalize tracking-wide group-hover:text-amber-500 cursor-pointer">
        Admissions
      </div>

      {isOpen && (
        <animated.div
          style={fadeInOut}
          className="absolute top-full left-0 bg-white text-gray-800 shadow-md p-4 mt-2 rounded-md border border-gray-200 flex flex-col z-10"
        >
          <NavLink text="Fees Chart" to="/FeesPage" />
          <NavLink text="Admission Enquiry" to="/AdmissionEnquiryPage" />
          <NavLink text="TC - Transfer Certificate" to="/TCPage" />
        </animated.div>
      )}
    </div>
  );
};

const NavLink = ({ text, to }) => (
  <Link
    to={to}
    className="text-gray-800 text-sm py-2 hover:text-blue-500 cursor-pointer block whitespace-nowrap transition-colors duration-300"
  >
    {text}
  </Link>
);

export default DropDownAdmissions;
